import { BOM_V2_ENABLED } from '../../../constants/bom-v2.constants';

export const rightsArray = [
  {
    rights: {
      products: [
        {
          _id: '6661574d90a89f2945736e1b',
          all: true,
          addEdit: true,
          delete: true,
          read: true,
          approveReject: true,
          switchstatus: true,
          label: 'Adding a Product',
          module: 'addProduct',
          section: {
            label: 'Products',
            switchStatus: true,
            _id: '6661574d90a89f2945736e1a',
          },
        },
        {
          _id: '6661574d90a89f2945736e93',
          all: false,
          addEdit: false,
          delete: false,
          read: true,
          approveReject: false,
          switchstatus: true,
          label: 'Product Identifier',
          module: 'productIdentifier',
          section: {
            label: 'Products',
            switchStatus: true,
            _id: '6661574d90a89f2945736e92',
          },
        },
        {
          _id: '6661574d90a89f2945736e1d',
          all: true,
          addEdit: true,
          delete: true,
          read: true,
          approveReject: true,
          switchstatus: true,
          label: 'Design/Details',
          module: 'design',
          section: {
            label: 'Products',
            switchStatus: true,
            _id: '6661574d90a89f2945736e1c',
          },
        },
        {
          _id: '6661574d90a89f2945736e1f',
          all: true,
          addEdit: true,
          delete: true,
          read: true,
          approveReject: true,
          switchstatus: true,
          label: 'Bill of Materials',
          module: 'bom',
          section: {
            label: 'Products',
            switchStatus: true,
            _id: '6661574d90a89f2945736e1e',
          },
        },
        {
          _id: '6661574d90a89f2945736e21',
          all: true,
          addEdit: true,
          delete: true,
          read: true,
          approveReject: true,
          switchstatus: true,
          label: 'Measurements',
          module: 'measurement',
          section: {
            label: 'Products',
            switchStatus: true,
            _id: '6661574d90a89f2945736e20',
          },
        },
        {
          _id: '6661574d90a89f2945736e23',
          all: true,
          addEdit: true,
          delete: true,
          read: true,
          approveReject: true,
          switchstatus: true,
          label: 'Testing',
          module: 'testing',
          section: {
            label: 'Products',
            switchStatus: true,
            _id: '6661574d90a89f2945736e22',
          },
        },
        {
          _id: '6661574d90a89f2945736e25',
          all: true,
          addEdit: true,
          delete: true,
          read: true,
          approveReject: true,
          switchstatus: true,
          label: 'Care/User Information',
          module: 'care',
          section: {
            label: 'Products',
            switchStatus: true,
            _id: '6661574d90a89f2945736e24',
          },
        },
        {
          _id: '6661574d90a89f2945736e27',
          all: true,
          addEdit: true,
          delete: true,
          read: true,
          approveReject: true,
          switchstatus: true,
          label: 'Samples',
          module: 'samples',
          section: {
            label: 'Products',
            switchStatus: true,
            _id: '6661574d90a89f2945736e26',
          },
        },
        {
          _id: '6661574d90a89f2945736e29',
          all: true,
          addEdit: true,
          delete: true,
          read: true,
          approveReject: true,
          switchstatus: true,
          label: 'Product Costing',
          module: 'costing',
          section: {
            label: 'Products',
            switchStatus: true,
            _id: '6661574d90a89f2945736e28',
          },
        },
        {
          _id: '6661574d90a89f2945736e2b',
          all: true,
          addEdit: true,
          delete: true,
          read: true,
          approveReject: true,
          switchstatus: true,
          label: 'Purchase Order',
          module: 'purchaseOrder',
          section: {
            label: 'Products',
            switchStatus: true,
            _id: '6661574d90a89f2945736e2a',
          },
        },
        {
          _id: '6661574d90a89f2945736e2d',
          all: true,
          addEdit: true,
          delete: true,
          read: true,
          approveReject: true,
          switchstatus: true,
          label: 'Trade References',
          module: 'tradeRef',
          section: {
            label: 'Products',
            switchStatus: true,
            _id: '6661574d90a89f2945736e2c',
          },
        },
        {
          _id: '6661574d90a89f2945736e2f',
          all: true,
          addEdit: true,
          delete: true,
          read: true,
          approveReject: true,
          switchstatus: true,
          label: 'Documents',
          module: 'documents',
          section: {
            label: 'Products',
            switchStatus: true,
            _id: '6661574d90a89f2945736e2e',
          },
        },
        {
          _id: '6661574d90a89f2945736e31',
          all: true,
          addEdit: true,
          delete: true,
          read: true,
          approveReject: true,
          switchstatus: true,
          label: 'Custom Module',
          module: 'customModule',
          section: {
            label: 'Products',
            switchStatus: true,
            _id: '6661574d90a89f2945736e30',
          },
        },
      ],
      libraries: [
        {
          _id: '6661574d90a89f2945736e33',
          all: false,
          addEdit: false,
          delete: false,
          read: true,
          approveReject: false,
          switchstatus: true,
          label: 'Colours',
          module: 'colours',
          section: {
            label: 'Libraries/Groups/Templates',
            switchStatus: true,
            _id: '6661574d90a89f2945736e32',
          },
        },
        {
          _id: '6661574d90a89f2945736e35',
          all: false,
          addEdit: false,
          delete: false,
          read: true,
          approveReject: false,
          switchstatus: true,
          label: 'Bill of Materials',
          module: 'bom',
          section: {
            label: 'Libraries/Groups/Templates',
            switchStatus: true,
            _id: '6661574d90a89f2945736e34',
          },
        },
        {
          _id: '6661574d90a89f2945736e37',
          all: false,
          addEdit: false,
          delete: false,
          read: true,
          approveReject: false,
          switchstatus: true,
          label: 'Points of Measure & Gradings',
          module: 'pomGrading',
          section: {
            label: 'Libraries/Groups/Templates',
            switchStatus: true,
            _id: '6661574d90a89f2945736e36',
          },
        },
        {
          _id: '6661574d90a89f2945736e39',
          all: false,
          addEdit: false,
          delete: false,
          read: true,
          approveReject: false,
          switchstatus: true,
          label: 'Spec Templates',
          module: 'spec',
          section: {
            label: 'Libraries/Groups/Templates',
            switchStatus: true,
            _id: '6661574d90a89f2945736e38',
          },
        },
        {
          _id: '6661574d90a89f2945736e3b',
          all: false,
          addEdit: false,
          delete: false,
          read: true,
          approveReject: false,
          switchstatus: true,
          label: 'Care Labels',
          module: 'care',
          section: {
            label: 'Libraries/Groups/Templates',
            switchStatus: true,
            _id: '6661574d90a89f2945736e3a',
          },
        },
        {
          _id: '6661574d90a89f2945736e3d',
          all: false,
          addEdit: false,
          delete: false,
          read: true,
          approveReject: false,
          switchstatus: true,
          label: 'Testing',
          module: 'testing',
          section: {
            label: 'Libraries/Groups/Templates',
            switchStatus: true,
            _id: '6661574d90a89f2945736e3c',
          },
        },
        {
          _id: '6661574d90a89f2945736e3f',
          all: false,
          addEdit: false,
          delete: false,
          read: true,
          approveReject: false,
          switchstatus: true,
          label: 'PO Templates',
          module: 'poTemplate',
          section: {
            label: 'Libraries/Groups/Templates',
            switchStatus: true,
            _id: '6661574d90a89f2945736e3e',
          },
        },
        {
          _id: '6661574d90a89f2945736e43',
          all: false,
          addEdit: false,
          delete: false,
          read: true,
          approveReject: false,
          switchstatus: true,
          label: 'Trade References',
          module: 'tradeRef',
          section: {
            label: 'Libraries/Groups/Templates',
            switchStatus: true,
            _id: '6661574d90a89f2945736e42',
          },
        },
        {
          _id: '6661574d90a89f2945736e45',
          all: false,
          addEdit: false,
          delete: false,
          read: true,
          approveReject: false,
          switchstatus: true,
          label: 'Costing Templates',
          module: 'costingTemplate',
          section: {
            label: 'Libraries/Groups/Templates',
            switchStatus: true,
            _id: '6661574d90a89f2945736e44',
          },
        },
        {
          _id: '6661574d90a89f2945736e47',
          all: false,
          addEdit: false,
          delete: false,
          read: true,
          approveReject: false,
          switchstatus: true,
          label: 'Custom Module',
          module: 'customModule',
          section: {
            label: 'Libraries/Groups/Templates',
            switchStatus: true,
            _id: '6661574d90a89f2945736e46',
          },
        },
        {
          _id: '6661574d90a89f2945736e95',
          all: false,
          addEdit: false,
          delete: false,
          read: true,
          approveReject: false,
          switchstatus: true,
          label: 'Retail Identifiers',
          module: 'retailIdentifier',
          section: {
            label: 'Libraries/Groups/Templates',
            switchStatus: true,
            _id: '6661574d90a89f2945736e94',
          },
        },
      ],
      rangePlan: [
        {
          _id: '6661574d90a89f2945736e49',
          all: false,
          addEdit: false,
          delete: false,
          read: true,
          approveReject: false,
          switchstatus: true,
          label: 'Default Product Listing',
          module: 'default',
          section: {
            label: 'Range Plan',
            switchStatus: true,
            _id: '6661574d90a89f2945736e48',
          },
        },
        {
          _id: '6661574d90a89f2945736e4b',
          all: false,
          addEdit: false,
          delete: false,
          read: true,
          approveReject: false,
          switchstatus: true,
          label: 'Custom Section Settings',
          module: 'custom',
          section: {
            label: 'Range Plan',
            switchStatus: true,
            _id: '6661574d90a89f2945736e4a',
          },
        },
        {
          _id: '6661574d90a89f2945736e4d',
          all: false,
          addEdit: false,
          delete: false,
          read: true,
          approveReject: false,
          switchstatus: true,
          label: 'Costingtemp_A (Custom Section)',
          module: 'costingtempA',
          section: {
            label: 'Range Plan',
            switchStatus: true,
            _id: '6661574d90a89f2945736e4c',
          },
        },
        {
          _id: '6661574d90a89f2945736e4f',
          all: false,
          addEdit: false,
          delete: false,
          read: true,
          approveReject: false,
          switchstatus: true,
          label: 'Costingtemp_B (Custom Section)',
          module: 'costingtempB',
          section: {
            label: 'Range Plan',
            switchStatus: true,
            _id: '6661574d90a89f2945736e4e',
          },
        },
        {
          _id: '6661574d90a89f2945736e51',
          all: false,
          addEdit: false,
          delete: false,
          read: true,
          approveReject: false,
          switchstatus: true,
          label: 'TestPQR_9991 (Custom Section)',
          module: 'testPqr9991',
          section: {
            label: 'Range Plan',
            switchStatus: true,
            _id: '6661574d90a89f2945736e50',
          },
        },
        {
          _id: '6661574d90a89f2945736e53',
          all: false,
          addEdit: false,
          delete: false,
          read: true,
          approveReject: false,
          switchstatus: true,
          label: 'EG-Test1 (Custom Section)',
          module: 'egTest1',
          section: {
            label: 'Range Plan',
            switchStatus: true,
            _id: '6661574d90a89f2945736e52',
          },
        },
        {
          _id: '6661574d90a89f2945736e55',
          all: false,
          addEdit: false,
          delete: false,
          read: true,
          approveReject: false,
          switchstatus: true,
          label: 'test1 (Custom Section)',
          module: 'test1',
          section: {
            label: 'Range Plan',
            switchStatus: true,
            _id: '6661574d90a89f2945736e54',
          },
        },
        {
          _id: '6661574d90a89f2945736e57',
          all: false,
          addEdit: false,
          delete: false,
          read: true,
          approveReject: false,
          switchstatus: true,
          label: 'new manual columns (Custom Section)',
          module: 'newManualColumns',
          section: {
            label: 'Range Plan',
            switchStatus: true,
            _id: '6661574d90a89f2945736e56',
          },
        },
        {
          _id: '6661574d90a89f2945736e59',
          all: false,
          addEdit: false,
          delete: false,
          read: true,
          approveReject: false,
          switchstatus: true,
          label: 'Test (Custom Section)',
          module: 'test',
          section: {
            label: 'Range Plan',
            switchStatus: true,
            _id: '6661574d90a89f2945736e58',
          },
        },
        {
          _id: '6661574d90a89f2945736e5b',
          all: false,
          addEdit: false,
          delete: false,
          read: true,
          approveReject: false,
          switchstatus: true,
          label: 'Costintemp_A (Custom Section)',
          module: 'costintempA',
          section: {
            label: 'Range Plan',
            switchStatus: true,
            _id: '6661574d90a89f2945736e5a',
          },
        },
        {
          _id: '6661574d90a89f2945736e97',
          all: false,
          addEdit: false,
          delete: false,
          read: true,
          approveReject: false,
          switchstatus: true,
          label: 'Product Identifier',
          module: 'productIdentifier',
          section: {
            label: 'Range Plan',
            switchStatus: true,
            _id: '6661574d90a89f2945736e96',
          },
        },
      ],
      criticalPath: [
        {
          _id: '6661574d90a89f2945736e5d',
          all: false,
          addEdit: false,
          delete: false,
          read: true,
          approveReject: false,
          switchstatus: true,
          label: 'Product',
          module: 'product',
          section: {
            label: 'Critical Paths',
            switchStatus: true,
            _id: '6661574d90a89f2945736e5c',
          },
        },
        {
          _id: '6661574d90a89f2945736e5f',
          all: false,
          addEdit: false,
          delete: false,
          read: true,
          approveReject: false,
          switchstatus: true,
          label: 'Operational',
          module: 'operational',
          section: {
            label: 'Critical Paths',
            switchStatus: true,
            _id: '6661574d90a89f2945736e5e',
          },
        },
      ],
      pim: [
        {
          all: false,
          addEdit: false,
          delete: false,
          read: true,
          section: {
            label: 'PIM',
            switchStatus: true,
            _id: '6661574d90a89f2945736e60',
          },
          switchstatus: true,
          approveReject: false,
        },
      ],
      planning: [
        {
          _id: '6661574d90a89f2945736e62',
          all: false,
          addEdit: false,
          delete: false,
          read: true,
          approveReject: false,
          switchstatus: true,
          label: 'Bottom Up',
          module: 'bottomUp',
          section: {
            label: 'Planning',
            switchStatus: true,
            _id: '6661574d90a89f2945736e61',
          },
        },
        {
          _id: '6661574d90a89f2945736e64',
          all: false,
          addEdit: false,
          delete: false,
          read: true,
          approveReject: false,
          switchstatus: true,
          label: 'Top Down',
          module: 'topDown',
          section: {
            label: 'Planning',
            switchStatus: true,
            _id: '6661574d90a89f2945736e63',
          },
        },
      ],
      placeholder: [
        {
          all: false,
          addEdit: false,
          delete: false,
          read: true,
          section: {
            label: 'Placeholder Management',
            switchStatus: true,
            _id: '6661574d90a89f2945736e65',
          },
        },
      ],
      supplierOverview: [
        {
          all: false,
          addEdit: true,
          delete: false,
          read: true,
          section: {
            label: 'Supplier Overview',
            switchStatus: true,
            _id: '6661574d90a89f2945736e66',
          },
          switchstatus: true,
          approveReject: true,
        },
      ],
      manuals: [
        {
          all: false,
          addEdit: false,
          delete: false,
          read: true,
          section: {
            label: 'Manuals/Documents',
            switchStatus: true,
            _id: '6661574d90a89f2945736e67',
          },
        },
      ],
      masters: [
        {
          _id: '6661574d90a89f2945736e69',
          all: false,
          addEdit: false,
          delete: false,
          read: true,
          approveReject: false,
          switchstatus: true,
          label: 'Brands',
          module: 'brand',
          section: {
            label: 'System Masters',
            switchStatus: true,
            _id: '6661574d90a89f2945736e68',
          },
        },
        {
          _id: '6661574d90a89f2945736e6b',
          all: false,
          addEdit: false,
          delete: false,
          read: true,
          approveReject: false,
          switchstatus: true,
          label: 'Seasons',
          module: 'season',
          section: {
            label: 'System Masters',
            switchStatus: true,
            _id: '6661574d90a89f2945736e6a',
          },
        },
        {
          _id: '6661574d90a89f2945736e6d',
          all: false,
          addEdit: false,
          delete: false,
          read: true,
          approveReject: false,
          switchstatus: true,
          label: 'Categories',
          module: 'category',
          section: {
            label: 'System Masters',
            switchStatus: true,
            _id: '6661574d90a89f2945736e6c',
          },
        },
        {
          _id: '6661574d90a89f2945736e6f',
          all: false,
          addEdit: false,
          delete: false,
          read: true,
          approveReject: false,
          switchstatus: true,
          label: 'Purchase Order Size',
          module: 'poSize',
          section: {
            label: 'System Masters',
            switchStatus: true,
            _id: '6661574d90a89f2945736e6e',
          },
        },
        {
          _id: '6661574d90a89f2945736e71',
          all: false,
          addEdit: false,
          delete: false,
          read: true,
          approveReject: false,
          switchstatus: true,
          label: 'Lengths',
          module: 'length',
          section: {
            label: 'System Masters',
            switchStatus: true,
            _id: '6661574d90a89f2945736e70',
          },
        },
        {
          _id: '6661574d90a89f2945736e73',
          all: false,
          addEdit: false,
          delete: false,
          read: true,
          approveReject: false,
          switchstatus: true,
          label: 'Units',
          module: 'units',
          section: {
            label: 'System Masters',
            switchStatus: true,
            _id: '6661574d90a89f2945736e72',
          },
        },
        {
          _id: '6661574d90a89f2945736e77',
          all: false,
          addEdit: false,
          delete: false,
          read: true,
          approveReject: false,
          switchstatus: true,
          label: 'Product/Component Type',
          module: 'prodCompTypes',
          section: {
            label: 'System Masters',
            switchStatus: true,
            _id: '6661574d90a89f2945736e76',
          },
        },
        {
          _id: '6661574d90a89f2945736e79',
          all: false,
          addEdit: false,
          delete: false,
          read: true,
          approveReject: false,
          switchstatus: true,
          label: 'Product Status',
          module: 'prodStatus',
          section: {
            label: 'System Masters',
            switchStatus: true,
            _id: '6661574d90a89f2945736e78',
          },
        },
        {
          _id: '6661574d90a89f2945736e7b',
          all: false,
          addEdit: false,
          delete: false,
          read: true,
          approveReject: false,
          switchstatus: true,
          label: 'Bom Sub-Type',
          module: 'bomSubTypes',
          section: {
            label: 'System Masters',
            switchStatus: true,
            _id: '6661574d90a89f2945736e7a',
          },
        },
        {
          _id: '6661574d90a89f2945736e7d',
          all: false,
          addEdit: false,
          delete: false,
          read: true,
          approveReject: false,
          switchstatus: true,
          label: 'Placement',
          module: 'placement',
          section: {
            label: 'System Masters',
            switchStatus: true,
            _id: '6661574d90a89f2945736e7c',
          },
        },
        {
          _id: '6661574d90a89f2945736e7f',
          all: false,
          addEdit: false,
          delete: false,
          read: true,
          approveReject: false,
          switchstatus: true,
          label: 'Finish',
          module: 'finishes',
          section: {
            label: 'System Masters',
            switchStatus: true,
            _id: '6661574d90a89f2945736e7e',
          },
        },
        {
          _id: '6661574d90a89f2945736e81',
          all: false,
          addEdit: false,
          delete: false,
          read: true,
          approveReject: false,
          switchstatus: true,
          label: 'Composition',
          module: 'composition',
          section: {
            label: 'System Masters',
            switchStatus: true,
            _id: '6661574d90a89f2945736e80',
          },
        },
        {
          _id: '6661574d90a89f2945736e83',
          all: false,
          addEdit: false,
          delete: false,
          read: true,
          approveReject: false,
          switchstatus: true,
          label: 'E-comm Specs',
          module: 'specs',
          section: {
            label: 'System Masters',
            switchStatus: true,
            _id: '6661574d90a89f2945736e82',
          },
        },
        {
          _id: '6661574d90a89f2945736e85',
          all: false,
          addEdit: false,
          delete: false,
          read: true,
          approveReject: false,
          switchstatus: true,
          label: 'Samples',
          module: 'samples',
          section: {
            label: 'System Masters',
            switchStatus: true,
            _id: '6661574d90a89f2945736e84',
          },
        },
        {
          _id: '6661574d90a89f2945736e87',
          all: false,
          addEdit: false,
          delete: false,
          read: true,
          approveReject: false,
          switchstatus: true,
          label: 'Exchange Rates',
          module: 'exchangeRates',
          section: {
            label: 'System Masters',
            switchStatus: true,
            _id: '6661574d90a89f2945736e86',
          },
        },
        {
          _id: '6661574d90a89f2945736e89',
          all: false,
          addEdit: false,
          delete: false,
          read: true,
          approveReject: false,
          switchstatus: true,
          label: 'Custom Attributes',
          module: 'customAttribute',
          section: {
            label: 'System Masters',
            switchStatus: true,
            _id: '6661574d90a89f2945736e88',
          },
        },
        {
          _id: '6661574d90a89f2945736e8b',
          all: false,
          addEdit: false,
          delete: false,
          read: true,
          approveReject: false,
          switchstatus: true,
          label: 'Product Groups',
          module: 'productGroups',
          section: {
            label: 'System Masters',
            switchStatus: true,
            _id: '6661574d90a89f2945736e8a',
          },
        },
        {
          _id: '6661574d90a89f2945736e8d',
          all: false,
          addEdit: false,
          delete: false,
          read: true,
          approveReject: false,
          switchstatus: true,
          label: 'Product Identifier',
          module: 'productIdentifier',
          section: {
            label: 'System Masters',
            switchStatus: true,
            _id: '6661574d90a89f2945736e8c',
          },
        },
        {
          _id: '6661574d90a89f2945736e8f',
          all: false,
          addEdit: false,
          delete: false,
          read: true,
          approveReject: false,
          switchstatus: true,
          label: 'Document Type',
          module: 'documentType',
          section: {
            label: 'System Masters',
            switchStatus: true,
            _id: '6661574d90a89f2945736e8e',
          },
        },
        {
          _id: '6661574d90a89f2945736e91',
          all: false,
          addEdit: false,
          delete: false,
          read: true,
          approveReject: false,
          switchstatus: true,
          label: 'Coasting Stage',
          module: 'coastingStage',
          section: {
            label: 'System Masters',
            switchStatus: true,
            _id: '6661574d90a89f2945736e90',
          },
        },
        {
          _id: '667a72e47103921df7d3b53b',
          all: false,
          addEdit: false,
          delete: false,
          read: true,
          approveReject: false,
          switchstatus: true,
          module: 'testType',
          label: 'Test Type',
          section: {
            label: 'System Masters',
            switchstatus: true,
            _id: '667a72e47103921df7d3b53c',
          },
        },
      ],
    },
  },
];

/**
 * The Libraries modules whose rights include Approve/Reject: Testing, and BOM for the BOM V2
 * colour approval bar (owner, 2026-10-09) — BOM only while the BOM V2 rollout flag is on.
 */
export const LIBRARY_APPROVE_MODULES = BOM_V2_ENABLED ? ['testing', 'bom'] : ['testing'];
